const scrollbarWidth = require("scrollbarwidth");

const handleOpenMenu = () => {
    $("body").addClass("page__locked").css({
        "margin-right": scrollbarWidth(),
    });
    $("#nav-mobile").addClass("active");
};

const handleCloseMenu = () => {
    $("body").removeClass("page__locked").css({
        "margin-right": 0,
    });
    $("#nav-mobile").removeClass("active");
};

$(function () {
    if ($("#nav-mobile").length === 0) return;

    $(document).on("click", ".js-nav-mobile-open", handleOpenMenu);
    $(document).on(
        "click",
        ".js-nav-mobile-close, .nav-mobile__overlay",
        handleCloseMenu
    );
});
